import React from 'react'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader';
import CardHalfHeight from './../cards/CardHalfHeight'
import CardFullHeight from './../cards/CardFullHeight'
import CardBasic from './../cards/CardBasic'
import { Grid, Row, Col } from 'react-bootstrap'

import GroupItem from '../group-item'


function GroupList({ groups, currentUser, onGroupAccept, onGroupReject }) {
  let createdGroupItems = groups.map((group, index) => {
    if (currentUser.email === group.creatorEmail) {
      return (
        <GroupItem
          key={index}
          group={group}
        />
      );
    }
  });

  let recievedGroupItems = groups.map((group, index) => {
    if (currentUser.email !== group.creatorEmail) {
      return (
        <GroupItem
          key={index}
          group={group}
          onGroupAccept={onGroupAccept}
          onGroupReject={onGroupReject}
        />
      );
    }
  });

  return (
    <div>
      <CardHalfHeight>
        <List>
          <Subheader className="housing-group-headers">GROUPS YOU HAVE CREATED</Subheader>
          {createdGroupItems}
        </List>
      </CardHalfHeight>
      <CardBasic>
        <List>
          <Subheader className="housing-group-headers">GROUP INVITES</Subheader>
          {recievedGroupItems}
        </List>
      </CardBasic>
    </div>

  );
}

export default GroupList



// WEBPACK FOOTER //
// ./src/views/components/group-list/index.js